
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import styled from "styled-components";
import { FaqsLayoutProps } from ".";
import { TContents } from "../../../customHooks/useContents";
import useHeaderTitleSetter from "../../../customHooks/useHeaderTitleSetter";
import useLastPath from "../../../customHooks/useLastPath";
import FaqsLayout from "../../../layout/FaqsLayout";
import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import { API_URL } from "config";
import useModal from "customHooks/useModal";
import { FAQPageJsonLd } from "next-seo";
import Link from "next/link";
import { getData } from "utils/getData";
type FaqsPageType = React.FC<FaqsLayoutProps> & {
    Layout: React.FC<FaqsLayoutProps>;
};
type Params = {
    key: string;
};
const escape = function (str) {
    return str?.replace(/\\\"/g, '"')?.replace(/[\"]/g, '\\"');
};
const FaqsPage: FaqsPageType = ({ faqs, questions }) => {
    const lastPath = useLastPath();
    const serverKeyFaqs = faqs?.find((f) => f?.key === lastPath);
    const { locale, query, asPath, replace } = useRouter();
    const { handleCloseModal, handleShowModal, showModal } = useModal();
    const hash = asPath.split("#")[1];
    const handleCloseAnswerModal = () => {
        handleCloseModal();
        setTimeout(() => {
            replace(`/help/faqs/${query.key}`);
        }, 250);
    };
    useHeaderTitleSetter({
        title: addEllipsis(serverKeyFaqs?.name, 20),
        section: null
    });
    if (!serverKeyFaqs)
        return null;
    return (<div className="d-flex flex-column ">
      <MolhamModalOffcanvas onHide={handleCloseAnswerModal} show={showModal} header={{
            label: questions.find((f) => f.id.toString() === hash)?.contents
                ?.question[locale],
            noCloseBtn: true
        }} body={{
            className: "p-0"
        }} size="lg">
        <StyledAnswer className="px-3 py-3 mb-0 fs-lg lh17" dangerouslySetInnerHTML={{
            __html: questions.find((f) => f.id.toString() === hash)?.contents
                ?.answer[locale]
        }}/>
      </MolhamModalOffcanvas>
      <FAQPageJsonLd mainEntity={questions.map((f) => ({
            questionName: f?.contents?.question[locale],
            acceptedAnswerText: escape(f?.contents?.answer[locale])
        }))}/>
      {questions.map((f, i) => {
            const isLast = i === questions.length - 1;
            return (<Link key={i} replace href={`/help/faqs/${query.key}#${f.id}`} className={"cursor text-decoration-0 text-white p-3 fs-lg fw-bold " +
                    (isLast ? "" : "border-bottom")} onClick={handleShowModal}>
            <span>
              <i className="fe-book me-2 "></i>
            </span>
            <span>{f?.contents?.question[locale]}</span>
          </Link>);
        })}
    </div>);
};
FaqsPage.Layout = FaqsLayout;
export default FaqsPage;
const getStaticProps: GetStaticProps<FaqsLayoutProps, Params> = async ({ locale, params, }) => {
    // const conts: TContents = await JSON.parse(
    //   await fs.readFile(
    //     path.join(process.cwd(), "constants", `contents-${locale}.json`),
    //     "utf8"
    //   )
    // );
    const res = await getData<TContents>(`${API_URL}/contents`, null, {
        locale
    });
    const conts = res.data;
    const layoutData: AboutLayoutProps["pages"] = conts.pages.map((page) => ({
        slug: page.slug,
        title: page.contents.title,
        description: page.contents.description
    }));
    return {
        props: {
            pages: layoutData,
            faqs: conts.faqs.map((faq) => ({
                key: faq.key,
                name: faq.name,
                description: faq.description
            })),
            questions: conts.faqs
                .find((faq) => faq.key === params.key)
                .faqs.map((faq) => ({
                ...faq,
                contents: {
                    ...faq.contents,
                    answer: {
                        [locale]: faq.contents.answer[locale]
                    },
                    question: {
                        [locale]: faq.contents.question[locale]
                    }
                }
            }))
        },
        revalidate: 1800
    };
};
export const getStaticPaths: GetStaticPaths<Params> = async ({ locales }) => {
    const filteredLocales = locales?.filter((locale) => locale !== "default");
    // const conts = await fetch(API_URL + "/contents");
    // const data = await conts.json() as TContents;
    const paths = (await Promise.all(filteredLocales?.map(async (locale) => {
        // const conts: TContents = await JSON.parse(
        //   await fs.readFile(
        //     path.join(process.cwd(), "constants", `contents-${locale}.json`),
        //     "utf8"
        //   )
        // );
        const res = await getData<TContents>(`${API_URL}/contents`, null, {
            locale
        });
        const conts = res.data;
        return conts?.faqs
            ?.filter((faq) => Boolean(faq.key))
            .map((faq) => {
            return {
                params: {
                    key: faq.key
                },
                locale
            };
        });
    }))).flat();
    // const paths = data?.faqs?.filter((faq)=>Boolean(faq.key)).map((faq) => {
    //   return filteredLocales.map((locale) => ({
    //     params: {
    //       key: faq.key,
    //     },
    //     locale,
    //   }));
    // }).flat();
    return {
        paths,
        fallback: false
    };
};
const StyledAnswer = styled.div `
  p {
    margin-bottom: 0;
  }
`;
function addEllipsis(text, num) {
    if (!text)
        return "";
    if (text.length <= num) {
        return text; // If the string is num characters or shorter, no need for ellipsis.
    }
    else {
        return text.substring(0, num) + "...";
    }
}

    async function __Next_Translate__getStaticProps__1a13f66c097__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help/faqs/[key]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66c097__ as getStaticProps }
  